import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable no-param-reassign */
import fetchAPI from 'utils/http/fetchAPI';
import dayjs from 'dayjs';
import { v4 as uuidv4 } from 'uuid';
import { EXPERIMENTS_CREATED, EXPERIMENTS_ERROR, EXPERIMENTS_SAVING } from 'redux/actionTypes/experiments';
import endUserMessages from 'utils/endUserMessages';
import handleError from 'utils/http/handleError';
var createExperiment = function createExperiment(name, description) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var createdAt, experimentId, newExperimentProperties, _errorMessage;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              createdAt = dayjs().toISOString();
              experimentId = uuidv4();
              newExperimentProperties = {
                id: experimentId,
                name: name,
                description: description
              };
              dispatch({
                type: EXPERIMENTS_SAVING
              });
              _context.prev = 4;
              _context.next = 7;
              return fetchAPI("/v2/experiments/".concat(experimentId), {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(newExperimentProperties)
              });
            case 7:
              dispatch({
                type: EXPERIMENTS_CREATED,
                payload: {
                  // TODO We don't really need to send this createdAt to redux, the real createdAt
                  // is being generated in the api
                  // We should make the POST to create the experiment return the new experiment and
                  // Take the createdAt from there
                  experiment: _objectSpread({
                    createdAt: createdAt
                  }, newExperimentProperties)
                }
              });
              _context.next = 14;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](4);
              _errorMessage = handleError(_context.t0, endUserMessages.ERROR_SAVING);
              dispatch({
                type: EXPERIMENTS_ERROR,
                payload: {
                  error: _errorMessage
                }
              });
            case 14:
              return _context.abrupt("return", Promise.resolve(experimentId));
            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 10]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default createExperiment;